export type AnalyticsEvent =
  | { name: "page_view"; path: string }
  | { name: "waitlist_started"; placement: "hero" | "footer" }
  | { name: "waitlist_submitted"; role: string; source: string }
  | { name: "waitlist_duplicate" }
  | { name: "waitlist_failed"; reason: string };

export interface AnalyticsAdapter {
  track(event: AnalyticsEvent): void;
}

const consoleAdapter: AnalyticsAdapter = {
  track(event) {
    if (import.meta.env.DEV || import.meta.env.VITE_ANALYTICS_MODE === "console") {
      console.info("[analytics]", event);
    }
  },
};

export const analytics: AnalyticsAdapter =
  import.meta.env.VITE_ANALYTICS_MODE === "off" ? { track: () => undefined } : consoleAdapter;
